import { Card, Col, Row, Space, Typography } from 'antd';
import Meta from 'antd/lib/card/Meta';
import { Page } from 'osep-react-antd';
import packageJson from '../../package.json';
import gitlabLogo from '../images/gitlab.png';
import multiCloudLogo from '../images/multiCloudLogo.png';
type Props = {
  error?: unknown;
};

const MainPage: React.FC<Props> = () => {
  return (
    <Page
      footer={<Typography.Text disabled>{packageJson.version}</Typography.Text>}
    >
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={12} lg={8} xl={6}>
          <Card
            title="Project Foundations"
            hoverable
            style={{
              position: 'relative',
              height: '100%',
            }}
            onClick={() => (window.location.href = '/projects')}
            cover={
              <Space style={{ textAlign: 'center' }}>
                <img
                  src={gitlabLogo}
                  alt="cover"
                  style={{
                    height: 100,
                    width: 'auto',
                    marginTop: 20,
                  }}
                />
              </Space>
            }
          >
            <Meta
              title="Bootstrap compliant software projects, the OSEP way."
              description="Create fully OSEP-integrated project foundations in minutes -
              complete with GitLab repositories, CI/CD pipelines, security
              scanning, quality gates, and documentation. Choose from curated
              blueprints for applications, libraries, infrastructure-as-code,
              and more."
            />
          </Card>
        </Col>

        <Col xs={24} sm={24} md={12} lg={8} xl={6}>
          <Card
            title="Platform Services"
            onClick={() => (window.location.href = '/ias')}
            hoverable
            style={{
              position: 'relative',
              height: '100%',
            }}
            cover={
              <Space style={{ textAlign: 'center' }}>
                <img
                  src={multiCloudLogo}
                  alt="cover"
                  style={{
                    height: 100,
                    width: 'auto',
                    marginTop: 20,
                  }}
                />
              </Space>
            }
          >
            <Meta
              title="On-demand capabilities for your projects."
              description="Provision OSEP-approved platform services such as GitLab runners,
              secure key vaults, shared infrastructure components, and other
              reusable capabilities - delivered through self-service and
              maintained by the platform."
            />
          </Card>
        </Col>
      </Row>
    </Page>
  );
};

export default MainPage;
